<template>
  <div>
    <div class="data-list-header">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">待审核退款订单</div>
            <div class="number">{{textForm.tobeReviewed || 0}}</div>
          </el-card>
        </el-col>
        <el-col :span="5">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">待退款订单</div>
            <div class="number">{{textForm.waitRefund || 0}}</div>
          </el-card>
        </el-col>
        <el-col :span="5">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">已退款订单</div>
            <div class="number">{{textForm.refunded || 0}}</div>
          </el-card>
        </el-col>
        <el-col :span="5">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">已退款线下</div>
            <div class="number">{{ textForm.offlineRefund || 0 }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">已退款线上</div>
            <div class="number">{{ textForm.onlineRefund || 0 }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="70px" size="mini">
          <el-form-item label="订单号" prop="orderNo" label-width="80px">
            <el-input class="form-input" v-model="searchForm.orderNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="用户名称" prop="name" label-width="80px">
            <el-input class="form-input" v-model="searchForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="活动ID" prop="activityId" label-width="80px">
            <el-input class="form-input" type="number" v-model="searchForm.activityId" clearable></el-input>
          </el-form-item>
         
          <el-form-item label="创建时间" prop="addTime" label-width="80px">
            <q-date-picker  v-model="searchForm" :isDefault="false" ref="dateRef" />
          </el-form-item>
          <el-form-item label="状态" prop="status" label-width="80px">
            <el-select v-model="searchForm.status" @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核销状态" prop="checkStatus" label-width="80px">
            <el-select v-model="searchForm.checkStatus" @change="onSearch">
              <el-option v-for="item in checkStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商" prop="cusName" label-width="80px">
            <el-input class="form-input"  v-model="searchForm.cusName" clearable></el-input>
          </el-form-item>
          <el-form-item label="门店" prop="storeName" label-width="80px">
            <el-input class="form-input" v-model="searchForm.storeName" clearable></el-input>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="exportFile">导出</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        border
        highlight-current-row
        :data="tableData"
        :height="maxTableHeight">
        <el-table-column type="index" label="编号" width="60" align="center"></el-table-column>
        <el-table-column prop="activityId" label="活动id" align="center" width="70"></el-table-column>
        <el-table-column prop="orderNo" label="订单号" align="center" width="270"></el-table-column>
        <el-table-column prop="joinUserName" label="用户名称" align="center" width="110"></el-table-column>
        <el-table-column prop="userPhone" label="联系方式" align="center" width="100"></el-table-column>
        <el-table-column prop="createdTime" label="创建订单时间" align="center" width="155"></el-table-column>
        <el-table-column prop="activityName" label="活动名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="joinActivityAmount" label="金额(元)"  width="80" align="center"></el-table-column>
        <el-table-column prop="sourceString" label="来源" align="center" width="70"></el-table-column>
        <el-table-column prop="cusName" label="经销商" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeName" label="门店" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="statusString" label="状态" width="120" align="center"></el-table-column>
        <el-table-column prop="reasonType" label="用户退款理由" width="120" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="additionalReason" label="用户补充退款理由" width="140"  show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="用户补充图片凭证" width="140" align="center">
          <template slot-scope="scope">
            <div class="img-box" v-if="scope.row.userImg.length">
              <el-image class="img" :src="scope.row.userImg[0]" :preview-src-list="scope.row.userImg"> </el-image>
              <span>x{{scope.row.userImg.length}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="rejectionReasonType" label="商家拒绝理由" width="120" show-overflow-tooltip  align="center">
          <template slot-scope="scope">
            <span>{{scope.row.rejectionReasonType | rejectionReasonStr}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reasonsRejection" label="商家补充退款理由" width="140" show-overflow-tooltip  align="center"></el-table-column>
        <el-table-column label="商家补充图片凭证" width="140" align="center">
          <template slot-scope="scope">
            <div class="img-box" v-if="scope.row.merchantImg.length">
              <el-image class="img" :src="scope.row.merchantImg[0]" :preview-src-list="scope.row.merchantImg"> </el-image>
              <span>x{{scope.row.merchantImg.length}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="offlineRefundTime" label="线下退款时间" width="155" show-overflow-tooltip  align="center"></el-table-column>
        <el-table-column prop="rejectionReasonType" label="线下退款凭证" width="120" show-overflow-tooltip  align="center">
          <template slot-scope="scope">
            <div class="img-box" v-if="scope.row.offlineImg.length">
              <el-image class="img" :src="scope.row.offlineImg[0]" :preview-src-list="scope.row.offlineImg"> </el-image>
              <span>x{{scope.row.offlineImg.length}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column  label="操作" width="200" class-name="action-column" align="center" fixed="right">
          <template v-slot="scope">
            <template v-if="scope.row.status == 2">
              <!-- <el-button type="text" size="small" @click="refundHandle(scope.row, true)">同意退款</el-button> -->
              <!-- <el-button type="text" size="small" v-if="scope.row.signupStatus == 7 " @click="refundHandle(scope.row, false)">拒绝退款</el-button>  -->
            </template>
            <el-button type="text" size="small" @click="refundDetail(scope.row)">退款日志</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
  <refund-detail :visible.sync="visible" :id="id"/>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import refundDetail from './components/refund-detail'
export default {
  name: "refundOrder",
  mixins: [tableMixin],
  components: { refundDetail },
  data() {
    return {
      searchForm: {
        orderNo: '',
        name: '',
        activityId: '',
        startTime: '',
        endTime: '',
        status: '',
        checkStatus: '',
        cusName: '',
        storeName: '',
      },
      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      id: '',
      statusOptions: [
        {value: '', label: '全部'},
        {value: -1, label: '已撤销'},
        {value: 0, label: '待退款'},
        {value: 1, label: '退款中'},
        {value: 2, label: '商家拒绝退款'},
        {value: 3, label: '平台拒绝退款'},
        {value: 4, label: '退款成功'},
        {value: 5, label: '已退款线下'},
      ],
      checkStatusOptions: [
        {value: '', label: '全部'},
        {value: 1, label: '已核销'},
        {value: 0, label: '未核销'},
      ],
      textForm: {},
      visible: false,
    }
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        }
      }
      this.$api.dataReport.refundDataPageList(params)
        .then(({data: {list, total}}) => {
          this.tableData = list.map(item => {
            return {
              ...item,
              userImg: this.formatImg(item.supplementaryPic),
              merchantImg: this.formatImg(item.rejectionSupplementaryPic),
              offlineImg: this.formatImg(item.offlineRefundProofPic)
            }
          })
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      for (const [key, val] of Object.entries(this.searchForm)) {
        this.filterParam[key] = val;
      }
      this.pageNum = 1;
      this.getList();
    },
    refundHandle(row, type) {
      let text = type ? '同意':'拒绝'
      this.$confirm(`确定${text}退款吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { orderNo } = row
        if (type) {
          await this.$api.dataReport.agreeRefund(orderNo)
        }else {
          await this.$api.dataReport.rejectRefund({reasonsRejection:'',orderNo})
        }
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
        this.findRefundInfo()
        this.init()
      })
    },
    findRefundInfo() {
      this.$api.dataReport.findRefundInfo()
        .then(res => {
          if (res.success) {
            this.textForm = res.data
          }
        })
    },
    formatImg(supplementaryPic) {
      let imgList = []
      if (supplementaryPic) {
       imgList = JSON.parse(supplementaryPic).map(item => item.url)
      }
      return imgList
    },
    refundDetail(row) {
      this.id= row.id
      this.visible = true
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    exportFile() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("refundDataPageList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    }
  },
  filters: {
    sourceType(state) {
      let map = {
        signUp: '报名',
        lottery: '抽奖',
        seckill: '秒杀',
        groupBuying: '拼团'
      }
      return map[state]
    },
    rejectionReasonStr(type) {
      let map = {
        1: '顾客已核销使用，无法退款', 
        2: '已线下退款给顾客',
        3: '已联系顾客，顾客同意不退款', 
        4: '其他原因'
      }
      return map[type]
    }
  },
 
  mounted() {
    this.findRefundInfo()
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
      text-align: center;
      padding: 6px 0;
    }
  }
  .img-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .img {
      width: 40px;
      height: 40px;
      margin: 4px 0;
      border-radius: 6px;
      cursor: pointer;
    }
    span {
      margin-left: 4px;
    }
  }
</style>